module.exports = __webpack_public_path__ + "static/profile-jessica-williams-e6e8d9d57a15ac9f15ad3000b27fe34b.png";